import React from 'react';
import { rilevaPiattaforma } from './platform';

export default function InstallHint({ open, onClose, onDontShow, deferredPrompt, onPromptUsed }) {
  if (!open) return null;
  const plat = rilevaPiattaforma(typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const installAndroid = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    try { await deferredPrompt.userChoice; } catch (e) { /* ignore */ }
    onPromptUsed && onPromptUsed();
    onClose();
  };
  return (
    <div className="m-install">
      <div className="m-install-head"><span>Installa come app</span><button onClick={onClose} aria-label="Chiudi">✕</button></div>
      {plat === 'ios' && (
        <div className="m-install-body">Tocca <b>Condividi</b> <span className="m-ico">⬆️</span> in basso, poi <b>"Aggiungi alla Home"</b>.</div>
      )}
      {plat === 'android' && (
        <div className="m-install-body">
          {deferredPrompt
            ? <button className="m-install-btn" onClick={installAndroid}>Installa</button>
            : <>Apri il menu <b>⋮</b> del browser e tocca <b>"Installa app"</b>.</>}
        </div>
      )}
      {plat === 'altro' && <div className="m-install-body">Apri questa pagina da uno smartphone per installarla come app.</div>}
      <button className="m-install-dont" onClick={onDontShow}>Non mostrare più</button>
    </div>
  );
}
